<template>
    <div class="bg-b">


        <div class="container">
            <el-row :gutter="100">


                <el-col :sm="14" :offset="0">
                    <div class="box2">
                        <h1 class="pt-sans-bol sub-h1">
                            Subdirección Formación Docente Continua e Investigación
                        </h1>
                    </div>
                    <div class="box3">
                        <h3 class="pt-sans-bol">

                            INSCRIPCIONES CERRADAS

                        </h3>
                        <small> Estamos trabajando para generar <br> nuevos trayectos formativos</small>

                        <el-button type="default1" style="margin-top:40px" @click="$router.push({name: 'normativa'})" size="default">Normativa</el-button>
                        <el-button type="borderblanco" style="margin-top:40px" @click="$router.push({name: 'listado'})" size="default">Capacitaciones</el-button>

                        <!-- <img src="@/assets/trabajando.png" alt=""> -->
                    </div>


                    <!-- <div class="box">
                        <div class="fold">
                            <h1 class="pt-sans-bol">

                                No hay capacitaciones disponibles
                                <small> Estamos trabajando para generar <br> nuevos trayectos formativos</small>
                            </h1>

                        </div>
                        <div class="msg">
                            Recuerde mantener actualizados sus datos en
                            <a href="https://sime.educaciontuc.gov.ar/" target="_blank"
                                rel="noopener noreferrer">SIME</a>

                        </div>
                        <img src="@/assets/iso.png" alt="">
                    </div> -->
                </el-col>
                <el-col :md="10">
                      <Login />
                  

                  
                </el-col>

            </el-row>

        </div>
    </div>
</template>

<script>
import Login from '@/components/login'
    export default {
    components: { Login },
        data() {
            return {
              
            }
        },
    }
</script>

<style lang="scss" scoped>
.box2{
    margin-top: 80px;
background: rgba(0, 0, 0, 0.05);
    padding:20px 10px;
    border-radius: 12px;
}
.box3 {
    margin-top: 20px;
   color: white;
    background: rgba(228, 24, 24, 0.3);
padding: 50px 30px;
    border-radius: 12px;
    text-align: center;
}
.box3 h3{
    font-size: 32px;
    // color:#174263;
}

.box3 small {
    font-size: 16px;
    display: block;
    margin-top: 10px;
    // color:#174263;
}
.sub-h1{
    color:white;
    font-size: 26px;
   
    text-align: center;
    text-transform: uppercase;
   
}
.sub-h1::before {
    background-image: linear-gradient(to right, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 100%);
}
.login{
    padding:30px
}
.msg{
    text-align: center;
    font-size: 13px;
    bottom: 10px;
    position: absolute;
    color: red;
    left: 20px;
    // border:1px dashed #ddd;
    // padding:10px;
    // width: 50%;
    // background: #f1f1f1;
}
.fold h1{
    color: #333;
    font-size: 32px;
    line-height: 1; margin: 0;
    text-align: center;
    margin: 0px;
    margin-top: 10%;
    // font-weight: normal;
  
}
.fold h1  > small{
    font-size: 18px;
    display: block;
 font-weight: normal;
    padding: 20px;
    color: #636060;
}
.box img {
    position: absolute;
    height: 60px;
    bottom:10px;
    left:auto;
    right:10px;
}
.box {
    position: relative;
    margin: 80px auto;
    width: 100%;
    height: 350px;
    background: rgba(255,255,255,1);
    border-radius: 0px;
    // padding: 20px;
    border-left: 8px solid #174263;
    border-top-right-radius:0%;
}
.fold {

    padding: 50px;
    // position: absolute;
   

}

/*
  paper fold corner
*/

.box:before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    border-style: solid;
    border-width: 0 30px 30px 0;
    border-color: #ddd #174263;
    transition: all ease .5s;
}

/*
  on li hover make paper fold larger
*/
.box:hover:before {
    border-width: 0 35px 35px 0;
    border-color: #eee #174263;
}



@keyframes background {
    0% {
        background-position: 0% 50%;
    }

    50% {
        background-position: 100% 50%;
    }

    100% {
        background-position: 0% 50%;
    }
}

</style>